export default __webpack_public_path__ + "static/media/bullet.2d8821cb.svg";